const HMO_OPTIONS = [
  { label: 'Hidden', value: 'HIDDEN' },
  { label: 'Mandatory', value: 'MANDATORY' },
  { label: 'Optional', value: 'OPTIONAL' }
]

const STRIKE_OPTIONS = [
  { label: 'Yes', value: 'YES' },
  { label: 'No', value: 'NO' }
]

const YES_OR_NO_OPTIONS = [
  { label: 'Yes', value: 'YES' },
  { label: 'No', value: 'NO' }
]

export enum RateOfContributionValues {
  RATE_1 = 'TICK~CROSS~CROSS', // 12% Gross
  RATE_2 = 'CROSS~TICK~CROSS', // 12% PF Wage
  RATE_3 = 'CROSS~CROSS~TICK' // Others
}

export const EMPLOYEE_NEW_JOINEE_UPLOAD_FIELDS_BLUEPRINT: FieldBlueprint[] = [
  {
    fieldId: 'UPLOAD_AADHAAR_FRONT',
    label: 'Aadhaar Front Side',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'UPLOAD_AADHAAR_BACK',
    label: 'Aadhaar Back Side',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'UPLOAD_PAN',
    label: 'PAN Copy',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'UPLOAD_PASSBOOK',
    label: 'PF Passbook',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'UPLOAD_SERVICE_HISTORY_SS',
    label: 'Service History SS',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  }
]

export const EMPLOYEE_NEW_JOINEE_BASIC_INFO_FIELDS_BLUEPRINT: FieldBlueprint[] = [
  {
    fieldId: 'NAME_AS_IN_AADHAAR',
    label: 'Name as in Aadhaar',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'YOUR_DATE_OF_BIRTH',
    label: 'Date of Birth',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'GENDER',
    label: 'Gender',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'FATHER_NAME',
    label: "Father's Name",
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'MARITAL_STATUS',
    label: 'Marital Status',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'BANK_ACCOUNT_NUMBER',
    label: 'Bank A/c Number',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'BANK_IFSC',
    label: 'Bank IFSC Code',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  }
]

export const EMPLOYEE_NEW_JOINEE_KYC_FIELDS_BLUEPRINT: FieldBlueprint[] = [
  {
    fieldId: 'PAN_NUMBER',
    label: 'PAN Number',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'AADHAAR_NUMBER',
    label: 'Aadhaar Number',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'SCHEME_CERTIFICATE_NUMBER',
    label: 'Scheme Certificate Number',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'PENSION_PAYMENT_ORDER_NUMBER',
    label: 'Pension Payment Order Number',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'PASSPORT_DETAILS',
    label: 'Passport ID, Origin, Issue From Date, Issue To Date',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  { fieldId: 'EPF_NOTES', label: 'EPF Notes', configurationType: 'FreeText', tooltip: 'Separated by triple tilde ~~~' },
  {
    fieldId: 'INTERNATIONAL_WORKER_NOTES',
    label: 'International Worker Notes',
    tooltip: 'Separated by triple tilde ~~~',
    configurationType: 'FreeText'
  },
  { fieldId: 'UPLOAD_FORM_11_NOTE', label: 'Upload Form 11 Note', configurationType: 'FreeText' }
]

export const EMPLOYEE_NEW_JOINEE_CONTACT_FIELDS_BLUEPRINT: FieldBlueprint[] = [
  {
    fieldId: 'MOBILE_NUMBER',
    label: 'Mobile Number',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'EMAIL_ID',
    label: 'Personal Mail ID',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'PERMANENT_ADDRESS',
    label: 'Address (All 8 fields)',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  }
]

export const ADMIN_NEW_JOINEE_UPLOAD_FIELDS_BLUEPRINT: FieldBlueprint[] = [
  {
    fieldId: 'UPLOAD_AADHAAR_FRONT',
    label: 'Aadhaar Front Side',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'UPLOAD_AADHAAR_BACK',
    label: 'Aadhaar Back Side',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'UPLOAD_PAN',
    label: 'PAN Copy',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'UPLOAD_PASSBOOK',
    label: 'PF Passbook',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'UPLOAD_SERVICE_HISTORY_SS',
    label: 'Service History SS',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  }
]

export const ADMIN_NEW_JOINEE_BASIC_INFO_FIELDS_BLUEPRINT: FieldBlueprint[] = [
  {
    fieldId: 'NAME_AS_IN_AADHAAR',
    label: 'Name as in Aadhaar',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'YOUR_DATE_OF_BIRTH',
    label: 'Date of Birth',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'GENDER',
    label: 'Gender',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'FATHER_NAME',
    label: "Father's Name",
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'MARITAL_STATUS',
    label: 'Marital Status',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'BANK_ACCOUNT_NUMBER',
    label: 'Bank A/c Number',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'BANK_IFSC',
    label: 'Bank IFSC Code',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  }
]

export const ADMIN_NEW_JOINEE_KYC_FIELDS_BLUEPRINT: FieldBlueprint[] = [
  {
    fieldId: 'PAN_NUMBER',
    label: 'PAN Number',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'AADHAAR_NUMBER',
    label: 'Aadhaar Number',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  { fieldId: 'EPF_NOTES', label: 'EPF Notes', configurationType: 'FreeText', tooltip: 'Separated by triple tilde ~~~' },
  {
    fieldId: 'INTERNATIONAL_WORKER_NOTES',
    label: 'International Worker Notes',
    tooltip: 'Separated by triple tilde ~~~',
    configurationType: 'FreeText'
  },
  { fieldId: 'UPLOAD_FORM_11_NOTE', label: 'Upload Form 11 Note', configurationType: 'FreeText' }
]

export const ADMIN_NEW_JOINEE_CONTACT_FIELDS_BLUEPRINT: FieldBlueprint[] = [
  {
    fieldId: 'MOBILE_NUMBER',
    label: 'Mobile Number',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'EMAIL_ID',
    label: 'Personal Mail ID',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  },
  {
    fieldId: 'PERMANENT_ADDRESS',
    label: 'Address (All 8 fields)',
    configurationType: 'HiddenMandatoryOptional',
    options: HMO_OPTIONS
  }
]

export const NEW_JOINEE_FORM11_PDF_FIELDS_BLUEPRINT: FieldBlueprint[] = [
  {
    fieldId: 'STRIKE_OFF_FOR_ENROLMENT_1A_1B',
    label: 'Strike Off Form 11',
    configurationType: 'StrikeOff',
    options: STRIKE_OPTIONS
  },
  {
    fieldId: 'RATE_OF_CONTRIBUTION',
    label: 'Rate of Contribution',
    configurationType: 'RateOfContribution',
    options: [
      { label: '12% Gross', value: RateOfContributionValues.RATE_1 },
      { label: '12% PF Wage', value: RateOfContributionValues.RATE_2 },
      { label: 'Others', value: RateOfContributionValues.RATE_3 }
    ]
  },
  { fieldId: 'UNDERTAKING_5TH_POINT', label: 'Undertaking Form 11 5th Point', configurationType: 'FreeText' },
  { fieldId: 'COMPANY_LAST_PAGE_SIGNATURE', label: 'Form 2(26) Company Info', configurationType: 'FreeText' },
  { fieldId: 'COMPANY_CONTACT_DETAILS', label: 'Form 2(26) Contact Info', configurationType: 'FreeText' },
  { fieldId: 'COMPANY_LOGO_LINK', label: 'Company Logo Link', configurationType: 'FreeText' },
  {
    fieldId: 'INCLUDE_26_6_FORM',
    label: 'Include form 26(6)',
    options: YES_OR_NO_OPTIONS,
    configurationType: 'YES_OR_NO'
  }
]

export interface FieldBlueprint {
  fieldId: string

  /** Label shown in UI table */
  label: string

  configurationType: 'HiddenMandatoryOptional' | 'StrikeOff' | 'RateOfContribution' | 'FreeText' | 'YES_OR_NO'

  /**
   * Optional override for dropdown options.
   * If provided → component uses these.
   * If NOT provided → component falls back to default enums.
   *
   * Each option has:
   *  - label: UI label (Human readable)
   *  - value: API value (ALL CAPS or enum value)
   */
  options?: { label: string; value: string }[]
  tooltip?: string
}
